import {
    JustpayPaymentSystemEndpointService
} from "@/views/loyalty/shared/endpoint_services/justpay-paymentsystem-endpoint-service"

export class JustpayPaymentSystemService {
    constructor () {
        this.justpayPaymentSystemEndpointService = new JustpayPaymentSystemEndpointService()
    }

    async createPayment (createPaymentRequest) {
        return this.justpayPaymentSystemEndpointService.createPayment(createPaymentRequest)
    }

    async getCheque (paymentId) {
        return this.justpayPaymentSystemEndpointService.getCheque(paymentId)
    }

    async getEntities (pointId) {
        return this.justpayPaymentSystemEndpointService.getEntities(pointId)
    }

    async getQrcode (pointId) {
        return this.justpayPaymentSystemEndpointService.getQrcode(pointId)
    }

    async getPaymentByIdempotency (idempotency) {
        return this.justpayPaymentSystemEndpointService.getPaymentByIdempotency(idempotency)
    }
}
